import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { Persona } from '@app/modules/personas/interfaces/persona.interface'
import { PersonaService } from '@app/modules/personas/services/persona.service'
import { EditorComponent } from '@app/modules/shared/components/editor/editor.component'
import { Subject } from 'rxjs'
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators'

@Component({
  selector: 'ngx-landing-description',
  templateUrl: './landing-description.component.html',
  styleUrls: ['./landing-description.component.scss'],
  imports: [CommonModule, EditorComponent]
})
export class LandingDescriptionComponent implements OnInit {
  @Input()
  persona: Persona
  @Output() descriptionChange = new EventEmitter<string>()
  description = ''
  contentSizeLimit = 1 * 1024 * 1024
  private _destroy$ = new Subject()

  constructor(private personaService: PersonaService) {}

  ngOnInit() {
    this.description = this.persona.public_description
  }

  /**
   * Updates the description with selected value
   * @param value string
   */
  update(value: string) {
    this.description = value
    this.descriptionChange.emit(this.description)
  }

  /**
   * Update description value
   */
  updateDescription() {
    const persona = { id: this.persona.id, public_description: this.description }
    this.personaService.updateForm(persona).pipe(distinctUntilChanged(), debounceTime(500), takeUntil(this._destroy$)).subscribe()
  }

  ngOnDestroy(): void {
    this._destroy$.next(null)
    this._destroy$.complete()
  }
}
